import React from "react";
import {
  FaLinkedinIn,
  FaReact,
  FaHtml5,
  FaCss3Alt,
  FaBootstrap,
  FaNodeJs,
  FaGithub,
  FaTwitter,
  FaDocker,
  FaPaypal,
  FaWhatsapp,
  FaKey,
  FaUserShield,
  FaStream,
  FaPlug,
  FaServer,
  FaSitemap,
} from "react-icons/fa";
import {
  SiJavascript,
  SiPython,
  SiSqlite,
  SiTypescript,
  SiMongodb,
  SiExpress,
  SiTailwindcss,
  SiNestjs,
  SiPrisma,
  SiGit,
  SiJest,
  SiPostman,
  SiFreelancer,
  SiAmazonaws,
  SiPostgresql,
  SiRedis,
  SiFastapi,
  SiNginx,
  SiGithubactions,
  SiRedux,
  SiMaterialui,
  SiFigma,
} from "react-icons/si";
import { TbNetwork, TbDatabase } from "react-icons/tb";
import { BsLayersHalf, BsShieldLock } from "react-icons/bs";
import { MdOutlineEngineering } from "react-icons/md";

const skillClusters = [
  {
    title: "Backend & APIs",
    skills: [
      { icon: <SiNestjs />, name: "NestJS" },
      { icon: <FaNodeJs />, name: "Node.js" },
      { icon: <SiExpress />, name: "Express.js" },
      { icon: <SiFastapi />, name: "FastAPI" },
      { icon: <SiPostman />, name: "REST APIs" },
      { icon: <FaPlug />, name: "API Integration" },
      { icon: <TbNetwork />, name: "WebSockets" },
      { icon: <FaStream />, name: "SSE Streaming" },
    ],
  },
  {
    title: "Frontend & Languages",
    skills: [
      { icon: <SiTypescript />, name: "TypeScript" },
      { icon: <SiJavascript />, name: "JavaScript" },
      { icon: <SiPython />, name: "Python" },
      { icon: <FaReact />, name: "React.js" },
      { icon: <SiRedux />, name: "Redux / RTK" },
      { icon: <BsLayersHalf />, name: "Zustand" },
      { icon: <SiTailwindcss />, name: "Tailwind CSS" },
      { icon: <SiMaterialui />, name: "Material-UI" },
      { icon: <FaBootstrap />, name: "Bootstrap" },
      { icon: <FaHtml5 />, name: "HTML5" },
      { icon: <FaCss3Alt />, name: "CSS3" },
    ],
  },
  {
    title: "Databases & Architecture",
    skills: [
      { icon: <SiPostgresql />, name: "PostgreSQL" },
      { icon: <SiMongodb />, name: "MongoDB" },
      { icon: <SiRedis />, name: "Redis" },
      { icon: <SiSqlite />, name: "SQLite" },
      { icon: <SiPrisma />, name: "Prisma ORM" },
      { icon: <TbDatabase />, name: "Database Design" },
      { icon: <FaSitemap />, name: "Multi-tenant" },
      { icon: <FaServer />, name: "Microservices" },
      { icon: <MdOutlineEngineering />, name: "System Design" },
      { icon: <TbNetwork />, name: "Real-time Systems" },
    ],
  },
  {
    title: "Cloud, Auth & Integrations",
    skills: [
      { icon: <SiAmazonaws />, name: "AWS EC2 / S3" },
      { icon: <FaDocker />, name: "Docker" },
      { icon: <SiNginx />, name: "Nginx" },
      { icon: <FaServer />, name: "PM2" },
      { icon: <SiGithubactions />, name: "CI/CD" },
      { icon: <FaKey />, name: "JWT" },
      { icon: <FaUserShield />, name: "RBAC" },
      { icon: <BsShieldLock />, name: "OAuth2 / bcrypt" },
      { icon: <FaPaypal />, name: "PayPal" },
      { icon: <FaPlug />, name: "Trustly" },
      { icon: <FaPlug />, name: "Razorpay" },
      { icon: <FaPlug />, name: "Sportradar" },
      { icon: <FaPlug />, name: "Mercoa" },
      { icon: <FaWhatsapp />, name: "WhatsApp API" },
      { icon: <SiGit />, name: "Git / GitHub" },
      { icon: <SiJest />, name: "Jest" },
      { icon: <SiFigma />, name: "Figma" },
      { icon: <SiPostman />, name: "Postman" },
    ],
  },
];

const Media = () => {
  return (
    <div className="flex flex-col gap-10 w-full">
      <div>
        <h2 className="text-sm uppercase font-titleFont tracking-widest text-slate-400 mb-4 font-mono">
          Find me on
        </h2>
        <div className="flex gap-4">
          <a
            href="https://github.com/chandramouli35"
            target="_blank"
            rel="noopener noreferrer"
            className="bannerIcon"
          >
            <FaGithub />
          </a>
          <a
            href="https://www.linkedin.com/in/mouli-chandra/"
            target="_blank"
            rel="noopener noreferrer"
            className="bannerIcon"
          >
            <FaLinkedinIn />
          </a>
          <a
            href="https://x.com/Chandra37006776"
            target="_blank"
            rel="noopener noreferrer"
            className="bannerIcon"
          >
            <FaTwitter />
          </a>
          <a
            href="https://www.freelancer.in/u/Chandramouli1m"
            target="_blank"
            rel="noopener noreferrer"
            className="bannerIcon"
          >
            <SiFreelancer />
          </a>
        </div>
      </div>

      <div>
        <h2 className="text-sm uppercase font-titleFont tracking-widest text-slate-400 mb-6 font-mono">
          Skills & Technologies
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {skillClusters.map((cluster, idx) => (
            <div
              key={idx}
              className="p-5 rounded-2xl glass-panel flex flex-col gap-3"
            >
              <h3 className="text-xs uppercase font-semibold text-cyan-300 tracking-wider border-b border-white/10 pb-2 font-mono">
                {cluster.title}
              </h3>
              <div className="grid grid-cols-2 gap-3 pt-1">
                {cluster.skills.map((skill, sIdx) => (
                  <div
                    key={sIdx}
                    className="flex items-center gap-2.5 px-3 py-2 rounded-full bg-slate-950/60 border border-white/10 hover:border-cyan-400/40 hover:text-cyan-300 transition-all w-full"
                  >
                    <span className="text-base text-cyan-400 shrink-0">
                      {skill.icon}
                    </span>
                    <span className="text-xs text-slate-300 font-mono font-medium truncate">
                      {skill.name}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Media;
